import jwt_decode from "jwt-decode";
import {
  AUTH_LOGIN_FAIL,
  AUTH_LOGIN_REQUEST,
  AUTH_LOGIN_SCALE_MODAL_CLOSE,
  AUTH_LOGIN_SCALE_MODAL_SUCCESS,
  AUTH_LOGIN_SUCCESS,
  AUTH_LOGOUT,
  AUTH_LOGOUT_FAIL,
  AUTH_LOGOUT_SUCCESS,
  GET_CALIBRATION_DATE,
  RESET_CALIBRATION_DATE,
} from "src/constants/types";
import { getToken, isAuthenticated } from "../utils/storage";

export const initialState = {
  is_authenticated: isAuthenticated(),
  token: getToken(),
  loading: false,
  error: "",
  role: getToken() ? jwt_decode(getToken()).UserRole : "",
  userCompanyId: getToken() ? jwt_decode(getToken()).CompanyId : "",
  calib_date: localStorage.getItem("calibrationDate")
    ? JSON.parse(localStorage.getItem("calibrationDate"))
    : "",
  scales: [],
  tempToken: "",
  is_choose_scale: false,
};

export const authReducer = (state = initialState, actions) => {
  switch (actions.type) {
    case AUTH_LOGIN_REQUEST:
      return { ...state, loading: true };
    case AUTH_LOGIN_SCALE_MODAL_CLOSE:
      return { ...state, is_choose_scale: false };

    case AUTH_LOGIN_SUCCESS:
      return {
        ...state,
        is_authenticated: true,
        token: actions.payload.Token,
        userCompanyId: actions.payload.userCompanyId,
        loading: false,
        error: "",
        role: actions.payload.role,
      };
    case AUTH_LOGIN_SCALE_MODAL_SUCCESS:
      return {
        ...state,
        is_choose_scale: true,
        loading: false,
        error: "",
        scales: actions?.payload?.scales,
        tempToken: actions?.payload?.tempToken,
      };

    case AUTH_LOGIN_FAIL:
      return {
        ...state,
        error: actions.payload,
        loading: false,
      };

    case AUTH_LOGOUT:
      return {
        ...state,
        loading: true,
        scales: [],
        tempToken: "",
        is_choose_scale: false,
      };
    case AUTH_LOGOUT_SUCCESS:
      return {
        ...state,
        is_authenticated: false,
        token: "",
        error: "",
        role: "",
        loading: false,
      };
    case AUTH_LOGOUT_FAIL:
      return {
        ...state,
        loading: false,
      };

    case GET_CALIBRATION_DATE:
      return {
        ...state,
        calib_date: actions.payload,
      };
    case RESET_CALIBRATION_DATE:
      return {
        ...state,
        calib_date: "",
      };

    default:
      return state;
  }
};
